module.exports = __webpack_public_path__ + "img/slideVerify_06.fca9b86e.png";